export default __webpack_public_path__ + "static/media/DM.4ffb6557.svg";